import dayjs from "dayjs";
import tinycolor from "tinycolor2";

export const getFormattedDate = (date: Date) => {
  return dayjs(date).format("DD-MM-YYYY HH:MM");
};
export const Luminance = (color: string) => {
  return tinycolor(color).getLuminance() === 0 ? "#FFFFFF" : "#000000";
};
